import CloseIcon from '../../../assets/icons/close.svg?react';
import TargetIcon from '../../../assets/icons/target.svg?react';
import { useState, useEffect } from 'react';
import { useCreateNotificationRule } from '../../../hooks/queries/logQueries';
import Selector from '../../../components/Selector/Selector';
import { useAuthContext } from '../../../contexts/AuthContext';
import AlertSetUpTargetEditModal from './AlertSetUpTargetEditModal';
const AlertSetUpAppendSideModal = ({ onClose, onSuccess }) => {
  const { user } = useAuthContext();
  const createNotificationRule = useCreateNotificationRule();

  const [isNotificationTargetsModalOpen, setIsNotificationTargetsModalOpen] = useState(false);
  
  const [isPending, setIsPending] = useState(false);
  const [selectedConditionType, setSelectedConditionType] = useState(null);
  const [selectedConditionOperator, setSelectedConditionOperator] = useState(null);
  const [selectedConditionValue, setSelectedConditionValue] = useState(null);
  const [formData, setFormData] = useState({
    ruleName: null,
    conditionType: null,
    conditionOperator: null,
    conditionValue: null,
    isActive: true,
    userSysId: user.UserSysId,
    notificationTargets: [
    ]
  });


  const handleFormDataChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  const handleCreateNotificationRule = async () => {
    try {
      setIsPending(true);
      await createNotificationRule.mutateAsync(formData);
      onSuccess();
    } catch (error) {
      console.error('알림 설정 추가 실패:', error);
      alert('알림 설정 추가에 실패했습니다.');
    }
    finally {
      setIsPending(false);
    }
  }


  const transformNotificationTargetData = (data) => {
    if (!data?.Items) return [];
    return data.Items.map((item) => ({
      id: item.NotificationTargetSysId,
      label: item.TargetValue,
      data: item,
    }));
  };
  
  const getQueryKeys = (searchQuery) => {
    return ['targetValue', 'selector', searchQuery];
  };

  // LogLevel, Message, ServiceName, ErrorCode
  const conditionTypeOptions = [
    { id: 'LogLevel', label: 'LogLevel' },
    { id: 'Message', label: 'Message' },
    { id: 'ServiceName', label: 'ServiceName' },
    { id: 'ErrorCode', label: 'ErrorCode' },
  ];

  // 조건타입에 따른 연산자 옵션
  const getOperatorOptions = (conditionType) => {
    if (!conditionType) return [];
    
    switch (conditionType.id) {
      case 'LogLevel':
        return [
          { id: 'EQUAL', label: 'Equal' },
          { id: 'ALL', label: 'All' },
        ];
      case 'ServiceName':
      case 'ErrorCode':
        return [
          { id: 'EQUAL', label: 'Equal' },
          { id: 'NOT_EQUAL', label: 'Not Equal' },
          { id: 'CONTAINS', label: 'Contains' },
        ];
      case 'Message':
        return [
          { id: 'CONTAINS', label: 'Contains' },
        ];
      default:
        return [];
    }
  };

  const operatorOptions = getOperatorOptions(selectedConditionType);

  // LogLevel일 때 사용할 조건값 옵션
  const logLevelValueOptions = [
    { id: 'INFO', label: 'INFO' },
    { id: 'WARNING', label: 'WARNING' },
    { id: 'ERROR', label: 'ERROR' },
    { id: 'CRITICAL', label: 'CRITICAL' },
    { id: 'ALL', label: 'All' },
  ];

  const handleSubmitNotificationTargets = (targets) => {
    setFormData({ ...formData, notificationTargets: targets });
    setIsNotificationTargetsModalOpen(false);
  }

  // 조건타입 변경 시 연산자와 조건값 초기화
  useEffect(() => {
    if(selectedConditionType){
      setFormData(prev => ({ ...prev, conditionType: selectedConditionType.id }));
      // 조건타입 변경 시 연산자와 조건값 초기화
      setSelectedConditionOperator(null);
      setSelectedConditionValue(null);
      setFormData(prev => ({ ...prev, conditionOperator: null, conditionValue: null }));
    }
  }, [selectedConditionType]);
  
  useEffect(() => {
    if(selectedConditionOperator){
      setFormData(prev => ({ ...prev, conditionOperator: selectedConditionOperator.id }));
    }
  }, [selectedConditionOperator]);
  
  // LogLevel일 때 조건값 선택
  useEffect(() => {
    if(selectedConditionValue){
      setFormData(prev => ({ ...prev, conditionValue: selectedConditionValue.id }));
    }
  }, [selectedConditionValue]);

  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>알림 설정 추가</h3>
          <button className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>
              <td width="100px">
                <label htmlFor="ruleName" className='w-20 mr-10 text-b2-700 required'>규칙명</label>
              </td>
              <td>
                <input type="text" id="ruleName" name="ruleName" className='w-full input-primary' placeholder='알림명을 입력해주세요.' value={formData.ruleName} onChange={handleFormDataChange} />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="conditionType" className='w-20 mr-10 text-b2-700 required'>조건타입</label>
              </td>
              <td>
                <Selector id="conditionType" options={conditionTypeOptions} placeholder="조건타입을 선택해주세요." mode="local" value={selectedConditionType} onChange={setSelectedConditionType} enableSearch={false} />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="conditionOperator" className='w-20 mr-10 text-b2-700 required'>조건연산자</label>
              </td>
              <td>
                <Selector id="conditionOperator" options={operatorOptions} placeholder="조건연산자를 선택해주세요." mode="local" value={selectedConditionOperator} onChange={setSelectedConditionOperator} enableSearch={false} />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="conditionValue" className='w-20 mr-10 text-b2-700 required'>조건값</label>
              </td>
              <td>
                {selectedConditionType?.id === 'LogLevel' ? (
                  <Selector 
                    id="conditionValue" 
                    options={logLevelValueOptions} 
                    placeholder="조건값을 선택해주세요." 
                    mode="local" 
                    value={selectedConditionValue} 
                    onChange={setSelectedConditionValue} 
                    enableSearch={false} 
                  />
                ) : (
                  <input 
                    type="text" 
                    id="conditionValue" 
                    name="conditionValue" 
                    className='w-full input-primary' 
                    placeholder='조건값을 입력해주세요.' 
                    value={formData.conditionValue || ''} 
                    onChange={handleFormDataChange} 
                  />
                )}
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="isActive" className='w-20 mr-10 text-b2-700'>활성여부</label>
              </td>
              <td>
                <div className='flex align-center gap-2'>
                  <input type="checkbox" id="isActive" name="isActive" checked={formData.isActive} onChange={() => setFormData({ ...formData, isActive: !formData.isActive })} />
                  <label htmlFor="isActive" className='text-b2-400 text-gray-600'>활성</label>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="notificationTargets" className='w-20 mr-10 text-b2-700'>알림대상</label>
              </td>
              <td>
                <div className='flex align-center justify-between'>
                  <div className='flex align-center gap-2'>
                    <TargetIcon color='var(--gray-600)' width={20} height={20} />  
                    <p className='text-b2-400 text-gray-600'>{formData.notificationTargets.length}</p>
                  </div>
                  <button className='btn small-btn btn-style-5' onClick={() => setIsNotificationTargetsModalOpen(true)}>
                    대상 설정
                  </button>
                </div>
              </td>
            </tr>
          </table>
          <div className="mt-10">
            <button className="btn btn-primary big-btn w-full" onClick={handleCreateNotificationRule} disabled={isPending || !formData.ruleName || !formData.conditionType || !formData.conditionOperator || !formData.conditionValue}>{isPending ? '추가중...' : '추가'}</button>
          </div>
        </div>
      </div>
      {isNotificationTargetsModalOpen && (
        <AlertSetUpTargetEditModal onClose={() => setIsNotificationTargetsModalOpen(false)} target={formData.notificationTargets} onSubmit={handleSubmitNotificationTargets} />
      )}
    </div>
  )
}

export default AlertSetUpAppendSideModal